import {debounce} from 'lodash';
import {watch} from "vue";
import {useRouteQuery} from "@vueuse/router";
import {useSearchStore} from "@/stores/searchStore";

export function useSynchronizedUrlQuerySearchStore(queryParam: string = 'search', debounceTime: number = 300) {
  const searchQuery = useRouteQuery(queryParam, '');
  const searchStore = useSearchStore()

  searchStore.query = searchQuery.value
  watch(searchStore, debounce(val => {
    searchQuery.value = val.query;
  }, debounceTime), {
    immediate: true,
    flush: 'post',
  })

  watch(searchQuery, (val) => {
    const newVal = val as string || ''
    if (searchStore.query !== newVal) {
      searchStore.query = newVal
    }
  })
}
